import React from 'react'

import styled from 'styled-components'

import ExpandLessOutlined from '@mui/icons-material/ExpandLessOutlined'
import ExpandMoreOutlined from '@mui/icons-material/ExpandMoreOutlined'
import UnfoldMoreOutlined from '@mui/icons-material/UnfoldMoreOutlined'

import { color } from 'styles/colors'

interface SortIcon {
  sortDirection?: string | null;
}

const SortIcon = ({ sortDirection = null }: SortIcon) => {
  if (sortDirection === 'asc') {
    return <S.IconWrapper role="img" aria-label="sort ascending"><ExpandLessOutlined sx={{ fontSize: 25 }} /></S.IconWrapper>
  }

  if (sortDirection === 'desc') {
    return <S.IconWrapper role="img" aria-label="sort descending"><ExpandMoreOutlined sx={{ fontSize: 25 }} /></S.IconWrapper>
  }

  return (
    <S.IconWrapper aria-label="sort this column">
      <UnfoldMoreOutlined sx={{ fontSize: 30 }} />
    </S.IconWrapper>
  )
}

export default SortIcon

const S = {
  IconWrapper: styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    right: 0px;
    color: ${color('searchPlaceholder')};
  `
}
